import React from "react";
import {
  HeaderContainer,
  AppIconContainer,
  AppIcon,
  HeaderOptions,
  HeaderOption,
  BurgerExpander,
  SideMenu,
} from "./styles";
import AppLogo from "../../../../resources/homeLogo.png";
import getString from "../../../../config/strings";
import { useHistory } from "react-router";
import { isMobile } from "../../../../utils/common";
import MenuSVG from "../../../../resources/menu.svg";
import CloseSVG from "../../../../resources/close.svg";
import ReactGA from 'react-ga';

function Header() {
  let history = useHistory();
  const [expanded, setExpanded] = React.useState(false);
  if (isMobile()) {
    return (
      <HeaderContainer>
        <AppIconContainer>
          <AppIcon src={AppLogo} />
        </AppIconContainer>
        <BurgerExpander
          onClick={() => {
            setExpanded(!expanded);
          }}
          src={expanded ? CloseSVG : MenuSVG}
        />
        <SideMenu expanded={expanded}>
          <HeaderOption
            onClick={() => {
              ReactGA.pageview('/app/browser');
              ReactGA.event({
                category: 'Home',
                action: 'Clicked Dashboard from Header',
              });
              history.push("/app/browser");
            }}
          >
            {getString("Dashboard")}
          </HeaderOption>
          <HeaderOption  onClick={() => {
              window.location.href = "https://marketsentiment.substack.com";
            }}>{getString("Blog")}</HeaderOption>
        </SideMenu>
      </HeaderContainer>
    );
  } else {
    return (
      <HeaderContainer>
        <AppIconContainer>
          <AppIcon src={AppLogo} />
        </AppIconContainer>
        <HeaderOptions>
          <HeaderOption
            onClick={() => {
              ReactGA.pageview('/app/browser');
              ReactGA.event({
                category: 'Home',
                action: 'Clicked Dashboard from Header',
              });
              history.push("/app/browser");
            }}
          >
            {getString("Dashboard")}
          </HeaderOption>
          <HeaderOption
            onClick={() => {
              window.location.href = "https://marketsentiment.substack.com";
            }}
          >
            {getString("Blog")}
          </HeaderOption>
        </HeaderOptions>
      </HeaderContainer>
    );
  }
}
export default Header;
